import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { marqueeService, pollService } from '../api/services';
import PollWidget from './PollWidget';
import './MarqueeBar.css';

const MarqueeBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [popup, setPopup] = useState(null);
  const [marqueePoll, setMarqueePoll] = useState(null);
  const channel = new URLSearchParams(location.search).get('channel') || '';

  useEffect(() => {
    let cancelled = false;
    marqueeService.list(channel ? { channel } : {})
      .then((res) => { if (!cancelled) setItems(res.data || []); })
      .catch(() => { if (!cancelled) setItems([]); });
    return () => { cancelled = true; };
  }, [channel]);

  const handleClick = (item) => {
    // 綁定投票的跑馬燈：點擊開啟彈窗並載入投票，可當場投票（優先於外部連結）
    if (item.poll_id) {
      setPopup(item);
      setMarqueePoll(null);
      pollService.get(item.poll_id)
        .then((res) => setMarqueePoll(res.data))
        .catch(() => setMarqueePoll(null));
      return;
    }
    if (item.link_url) {
      if (item.link_url.startsWith('/')) navigate(item.link_url);
      else window.open(item.link_url, '_blank', 'noopener,noreferrer');
      return;
    }
    if (item.popup_content) setPopup(item);
  };

  const closePopup = () => { setPopup(null); setMarqueePoll(null); };

  if (!items.length) return null;

  return (
    <>
      <div className="marquee-bar">
        <div className="marquee-track">
          {items.map((item) => (
            <button key={item.id} type="button" className="marquee-item" style={{ color: item.color || undefined, fontStyle: item.font_style || 'normal' }} onClick={() => handleClick(item)}>
              {item.content}
            </button>
          ))}
        </div>
      </div>
      {popup && (
        <div className="marquee-modal-backdrop" role="dialog" aria-modal="true">
          <div className="marquee-modal">
            <button type="button" className="marquee-modal-close" onClick={closePopup}>×</button>
            <h3>{popup.content}</h3>
            {popup.popup_content && <div className="marquee-popup-content">{popup.popup_content}</div>}
            {popup.poll_id && (
              marqueePoll
                ? <PollWidget poll={marqueePoll} onUpdate={setMarqueePoll} />
                : <div className="marquee-popup-content">投票載入中...</div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default MarqueeBar;